import { createSelector } from '@reduxjs/toolkit';

import { DynamicScreens } from '@cashier/cashier-model';
import { getCurrencySymbol } from '@cashier/cashier-shared';

import {
  CUSTOMER_INFORMATION_KEY,
  CustomerInformation,
} from './customerInformation.slice';

export const getCustomerInformation = (rootState: any): CustomerInformation =>
  rootState[CUSTOMER_INFORMATION_KEY];

export const selectActiveScreen = createSelector(
  getCustomerInformation,
  (s) => s.activeScreen,
);

export const selectAmount = createSelector(
  getCustomerInformation,
  (s) => s.amount,
);

export const selectBalance = createSelector(
  getCustomerInformation,
  (s) => s.balance,
);

export const selectBonusCode = createSelector(
  getCustomerInformation,
  (s) => s.bonusCode,
);

export const selectCurrencySymbol = createSelector(
  getCustomerInformation,
  (s) => getCurrencySymbol(s.currency),
);

export const selectFinalScreenActivated = createSelector(
  getCustomerInformation,
  (s) => s.activeScreen === DynamicScreens.FinalScreen,
);

export const selectProcessingResultSectionActivated = createSelector(
  getCustomerInformation,
  (s) => s.activeScreen === DynamicScreens.ProcessingResult,
);

export const selectPaymentFormActivated = createSelector(
  getCustomerInformation,
  (s) => s.activeScreen === DynamicScreens.PaymentForm,
);

export const selectConfirmationFormActivated = createSelector(
  getCustomerInformation,
  (s) => s.activeScreen === DynamicScreens.ConfirmationForm,
);
